/* Native details remain usable without JavaScript; add dismissal and one-open-at-a-time behavior. */
(() => {
  function init(header) {
    if (header.dataset.navigationReady) return;
    header.dataset.navigationReady = 'true';
    const groups = [...header.querySelectorAll('[data-nav-group]')];
    const mobile = header.querySelector('.site-mobile-menu');
    const breakpoint = matchMedia('(min-width:960px)');
    const closeAll = () => {
      groups.forEach(group => { group.open = false; });
      if (mobile) mobile.open = false;
    };
    groups.forEach(group => group.addEventListener('toggle', () => {
      if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
    }));
    const outside = event => { if (!header.contains(event.target)) closeAll(); };
    const escape = event => {
      if (event.key !== 'Escape') return;
      const focused = event.target.closest('details[open]');
      const open = focused || groups.find(group => group.open) || (mobile?.open ? mobile : null);
      if (!open) return;
      event.preventDefault();
      open.open = false;
      open.querySelector(':scope > summary')?.focus();
    };
    const focusout = event => {
      if (breakpoint.matches && event.relatedTarget && !header.contains(event.relatedTarget)) closeAll();
    };
    document.addEventListener('pointerdown', outside);
    header.addEventListener('keydown', escape);
    header.addEventListener('focusout', focusout);
    breakpoint.addEventListener('change', closeAll);
    header.cleanupNavigation = () => {
      document.removeEventListener('pointerdown', outside);
      header.removeEventListener('keydown', escape);
      header.removeEventListener('focusout', focusout);
      breakpoint.removeEventListener('change', closeAll);
    };
  }
  document.querySelectorAll('[data-navigation]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-navigation]').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-navigation]').forEach(header => header.cleanupNavigation?.()));
})();
